<template>
    <div :class="marketingItemClasses">
        <div class="upsell-marketing-item__text">
            <div class="upsell-marketing-item__text-label">
                <p class="typographies-paragraph-medium-regular">
                    {{ label }}
                </p>
                <CompassTooltip :content="tooltipText">
                    <CompassIcon icon="info-circle-fill" size="small" type="secondary" />
                </CompassTooltip>
            </div>
            <p
                v-if="description.length > 0"
                class="upsell-marketing-item__text-description typographies-paragraph-small-regular"
            >
                {{ description }}
            </p>
        </div>
        <CompassTooltip
            v-if="!enabled"
            :content="
                $t.__(
                    'pages.account.upsell.marketing.ChargebeeUpsellMarketingItemEmailPack.option_not_available',
                )
            "
        >
            <CompassFeatureBadge
                v-if="!enabled"
                :is-interactive="false"
                size="small"
                variant="upsell"
            />
        </CompassTooltip>
        <CompassNumberInput
            :disabled="!enabled"
            :min="0"
            :model-value="numberChosen"
            :step="1"
            @change="(quantity) => onNumberChosenChange(quantity)"
        />
        <p class="upsell-marketing-item__price">
            <span class="typographies-paragraph-medium-semibold">
                {{ humanizeCentsPrice(amount) | numberformatCurrency }}
            </span>
            <span class="typographies-paragraph-medium-regular">
                / {{ recurrencyLabel(getRecurrence) }}
            </span>
        </p>
        <div v-if="enabled" class="pack-marketing-email-supp__counter">
            <p class="pack-marketing-email-supp__counter-include">
                <span
                    class="typographies-paragraph-medium-regular pack-marketing-email-supp__counter-title"
                >
                    {{ $l10n.__('Inclus') }}
                </span>
                <span class="typographies-paragraph-medium-semibold">
                    {{ 10000 | numberformatWithOptions({ precision: 0 }) }}
                </span>
            </p>
            <p>
                <span
                    class="typographies-paragraph-medium-regular pack-ma rketing-email-supp__counter-title"
                >
                    {{ $l10n.__('Total') }}
                </span>
                <span class="typographies-paragraph-medium-semibold">
                    {{ (10000 + 10000 * numberChosen) | numberformatWithOptions({ precision: 0 }) }}
                </span>
            </p>
        </div>
    </div>
</template>
<script>
import ChargebeeUpsellMarketingItem from 'vcomponents/pages/account/upsell/marketing/ChargebeeUpsellMarketingItem.vue';
export default {
    extends: ChargebeeUpsellMarketingItem,
    props: {
        numberChosen: {
            type: Number,
            required: true,
        },
    },
    methods: {
        onNumberChosenChange(quantity) {
            this.$emit('onNumberChosenChange', quantity || 0);
        },
    },
};
</script>

<style lang="scss" scoped>
.upsell-marketing-item {
    align-items: center;
    display: grid;
    gap: var(--spacing-1) var(--spacing-3);
    grid-template-columns: repeat(3, auto);
    justify-content: space-between;

    &--disabled {
        grid-template-columns: repeat(4, auto);
        .pack-marketing-email-supp__counter {
            grid-column: 3;
        }
    }
    &:not(&--disabled) {
        .pack-marketing-email-supp__counter {
            grid-column: 2;
        }
    }

    .pack-marketing-email-supp__counter {
        align-items: center;
        background: var(--colors-common-background-subtle);
        border-radius: 4px;
        display: flex;
        padding: var(--spacing-1) var(--spacing-3);

        p {
            display: flex;
            flex-direction: column;
        }

        &-include {
            border-right: 1px solid var(--colors-common-border-lighter);
            color: var(--colors-common-text-standard-caption);
            margin-right: var(--spacing-1);
            padding-right: var(--spacing-1);
        }

        &-title {
            color: var(--colors-common-text-standard-caption);
        }
    }
}
</style>
